import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=9bf47e8a&scoped=true&"
import script from "./Seminar.vue?vue&type=script&lang=js&"
export * from "./Seminar.vue?vue&type=script&lang=js&"
import style0 from "./Seminar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Seminar.vue?vue&type=style&index=1&id=9bf47e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf47e8a",
  null
  
)

export default component.exports